import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DynamicCssLoader from "../components/DynamicCssLoader";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  useEffect(() => {
    // Add script initialization here if needed
    const script = document.createElement("script");
    script.src = "/js/main.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <DynamicCssLoader />
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default MainLayout;
